module.exports = __webpack_public_path__ + "img/abl_logo.558492c4.png";